import { readable, writable } from 'svelte/store';

export const db = readable(firebase.firestore(), function start() {

    return function stop() {

    };
});

export const auth = readable(firebase.auth(), function start() {

    return function stop() {

    };
});

export const functions = readable(firebase.functions(), function start() {

    return function stop() {

    };
});


export const user = writable(undefined);